controllers.controller('MenuController', [
    '$scope', '$state', '$ionicLoading',
    'LoginService', 'LocaleService', 'UserService', 'constants', 'Storage', 'config', 'API', '$ionicModal', 'IntercomService',
    function ($scope, $state, $ionicLoading, LoginService, LocaleService, UserService, Const, Storage, config, API, $ionicModal, IntercomService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };

        $scope.tradingCentralValidated = Storage.get('validateTCFeatures') || false;

        $scope.intercomService = IntercomService;

        $scope.tradingCentralConfig = Storage.get('additionalContent');
        if($scope.tradingCentralConfig){
            $scope.tradingCentralEnabled = Storage.get('additionalContent').find(function(item){
                return item.type === 'tradingCentral';
            }).enabled;
        }

        var navigate = function (state) {
            $state.go(state);
        };

        $scope.lang = LocaleService.lang;
        $scope.constants = Const;
        $scope.user = UserService.get();
        $scope.friendInviteActive = Storage.get('friendInviteActive');

        $scope.verificationRequired = Storage.get('verification');
        $scope.authType = Const['authType'] ? Const['authType'] : 'newforex';

        $scope.redirectOnLogoutURL = Const['redirectOnLogoutURL'] || false;

        var _defaultMenuItems = [
            {
                id: 'manageAccounts',
                name: 'Manage Accounts',
                translationKey: 'manage_accounts',
                iconClass: 'icon-ManageAccounts',
                onTap: function(){
                    navigate('root.app.manageAccounts')
                },
                displayCondition: true,
                displayOrder: 100
            },
            {
                id: 'transactionHistory',
                name: 'Transaction History',
                translationKey: 'transaction',
                iconClass: 'icon-TransactionHistory',
                onTap: function(){
                    navigate('root.app.transactionHistory')
                },
                displayCondition: true,
                displayOrder: 200
            },
            {
                id: 'personalDetails',
                name: 'Personal Details',
                translationKey: 'personalDetails',
                iconClass: 'icon-AccountDetails',
                onTap: function(){
                    navigate('root.app.personalDetails')
                },
                displayCondition: true,
                displayOrder: 300
            },
            {
                id: 'updatepassword',
                name: 'Change Password',
                translationKey: 'updatePassword',
                iconClass: 'icon-ChangePassword',
                onTap: function(){
                    navigate('root.app.updatepassword')
                },
                displayCondition: true,
                displayOrder: 400
            },
            {
                id: '2fa',
                name: 'Manage Security',
                translationKey: 'manageSecurity',
                iconClass: 'icon-ChangePassword',
                onTap: function(){
                    navigate('root.app.2fa')
                },
                displayCondition: Const.enable2FA,
                displayOrder: 500
            },
            {
                id: 'wallet',
                name: 'Deposit',
                translationKey: 'deposit',
                iconClass: 'icon-Wallet',
                onTap: function(){
                    navigate('root.app.wallet')
                },
                displayCondition: true,
                displayOrder: 600
            },
            {
                id: 'withdraw',
                name: 'Withdraw',
                translationKey: 'withdraw',
                iconClass: 'icon-withdraw',
                onTap: function(){
                    navigate('root.app.withdraw')
                },
                displayCondition: true,
                displayOrder: 700
            },
            // Old verification
            {
                id: 'uploadDocuments',
                name: 'Account Verification',
                translationKey: 'accountVerification',
                iconClass: 'icon-AccountVerification',
                onTap: function(){
                    navigate('root.app.uploadDocuments')
                },
                displayCondition:
                    !Const['hideAccountVerification'] &&
                    (!Const['verificationProvider'] || Const['verificationProvider'] === 'internal'),
                displayOrder: 800
            },
            // Verification-v2
            {
                id: 'verification-v2',
                name: 'Account Verification',
                translationKey: 'accountVerification',
                iconClass: 'icon-AccountVerification',
                onTap: function(){
                    navigate('root.app.verification-v2')
                },
                displayCondition:
                    !Const['hideAccountVerification'] &&
                    (Const['verificationProvider'] === 'internal-v2'),
                displayOrder: 900,
                specialType: 'verification-v2'
            },
            // Sum Sub verification
            {
                id: 'sumsub',
                name: 'Account Verification',
                translationKey: 'accountVerification',
                iconClass: 'icon-AccountVerification',
                onTap: function(){
                    navigate('root.app.sumsub')
                },
                displayCondition:
                    !Const['hideAccountVerification'] &&
                    (Const['verificationProvider'] === 'sumsub'),
                displayOrder: 1000
            },
            {
                id: 'inviteFriends',
                name: 'Invite A Friend',
                translationKey: 'invite_a_friend',
                iconClass: 'icon-accounts',
                onTap: function(){
                    navigate('root.app.inviteFriends')
                },
                displayCondition: $scope.friendInviteActive || false,
                displayOrder: 1100
            },
            {
                id: 'viewQuestionnaire',
                name: 'View Questionnaire',
                translationKey: 'viewQuestionnaire',
                iconClass: 'icon-list2',
                onTap: function(){
                    navigate('root.app.viewQuestionnaire')
                },
                displayCondition: Const['viewQuestionnaireEnable'],
                displayOrder: 1200
            },
            {
                id: 'logout',
                name: 'Logout',
                translationKey: 'logout',
                iconClass: 'icon-Logout',
                onTap: function(){
                    $scope.logout();
                },
                displayCondition: true,
                displayOrder: 9999
            }
        ]
        var generateMenuItems = function(defaultMenuItems, configMenuItems){
            var newMenuItems = [];

            configMenuItems.forEach(function (configMenuItem){
                var duplicate = defaultMenuItems.find(function (defaultMenuItem, index){
                    if(defaultMenuItem.id === configMenuItem.id){
                        defaultMenuItems[index] = configMenuItem;
                    }
                    return defaultMenuItem.id === configMenuItem.id;
                })
                if(!duplicate){
                    switch (configMenuItem.specialType){
                        case 'tradingCentral':
                            configMenuItem.displayCondition = $scope.tradingCentralEnabled;
                            configMenuItem.onTap = function(){
                                $scope.openTradingCentral(configMenuItem.tradingCentralFeatureName)
                            };
                            break;
                        case 'img-link':
                            configMenuItem.displayCondition = $scope.tradingCentralEnabled;
                            configMenuItem.onTap = function(){
                                $scope.openTradingCentral(configMenuItem.tradingCentralFeatureName)
                            };
                            break;
                        default:
                            configMenuItem.displayCondition = true;
                            break;

                    }
                    newMenuItems.push(configMenuItem);
                }
            });
            return defaultMenuItems.concat(newMenuItems, config.customLinks);
        }
        $scope.menuItems = generateMenuItems(_defaultMenuItems, config.menuItems || []);


        var userWatch = $scope.$watch(UserService.get, function(newVal, oldVal){
            if (newVal !== oldVal && newVal) {
                $scope.user = UserService.get();
            }
        });

        $scope.customLinks = config.customLinks || [];

        $scope.openTradingCentral = function (tradingCentralFeaturePageName){


            if(!$scope.tradingCentralValidated){

                // TODO: Currency presentation, Confirm and compare with dev - Where the value set?
                var minDepositCurrency =
                    Const.currencySymbols[$scope.user.activeTradingAccount.currency] ||
                    Const.currencySymbols[$scope.user.baseCurrency] ||
                    $scope.user.baseCurrency;

                var featureBlockedMessage = $scope.translation['trading_central_not_validated'] ||
                    'Your account must have minimum of %minTotalDeposit% to access Trading Tools';
                $scope.modal.textContent = featureBlockedMessage.replace("%minTotalDeposit%", [Const.tradingCentralMinTotalDeposit || 0, minDepositCurrency].join(''));
                $scope.modal.textTitle = LocaleService.translation.trading_central || 'Trading Central';
                $scope.modal.isError = true;
                $scope.modal.actionText = LocaleService.translation.continueTrading;
                $scope.modal.back = 'root.app.menu';
                $scope.modal.state = true;
                return;
            }

            API.generateTCLink({page: tradingCentralFeaturePageName, theme: config.tradingCentralTheme || 'white'}).then(function(response){
                window.open(response.redirectUrl + "&lang=" + ($scope.lang || 'en'));
            });
        }

        $scope.logout = function () {
            Storage.remove('registration');
            $scope.loadingMessage = LocaleService.translation.logging_out;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            IntercomService.shutdown();

            LoginService.logout()
                .then(function () {
                    $ionicLoading.hide();
                    if($scope.redirectOnLogoutURL){
                        window.location.replace($scope.redirectOnLogoutURL + "?lang=" + ($scope.lang || 'en'));
                    } else {
                        $state.go('welcome');
                    }
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    if($scope.redirectOnLogoutURL){
                        window.location.replace($scope.redirectOnLogoutURL + "?lang=" + ($scope.lang || 'en'));
                    } else {
                        $state.go('welcome');
                    }
                });
        };

        $scope.$on('clear', function () {
            userWatch();
        });

        $scope.openCustomLinkByLang = function(link) {
            var url = link[$scope.lang] ? link[$scope.lang].url : link.en.url
            window.open(url);
        }

        $scope.openLink = function(link) {
            window.open(Const.externalLinks[link]);
        }

    }]);
